import { IconButton, IconButtonVariant } from '@creditornot/cb-button';
import { Popover } from '@creditornot/cb-popover';
import React from 'react';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

type Props = {
  disabled?: boolean;
  disableEndMargin?: boolean;
  icon: React.ReactNode;
  iconButtonVariant?: IconButtonVariant;
  onClick: () => void;
  tooltipTitle: React.ReactNode;
};

const Root = styled(Popover).attrs({
  showOnClick: false,
  renderArrow: true,
  placement: 'top',
})<{ disableEndMargin: boolean }>`
  margin-inline-end: ${props => (props.disableEndMargin ? '0' : '16px')};
`;

const PopoverContent = styled(T.Body3)`
  display: flex;
  max-width: 240px;
`;

const ActionButton = ({
  disabled = false,
  disableEndMargin = false,
  icon,
  iconButtonVariant = 'black',
  onClick,
  tooltipTitle,
}: Props) => {
  return (
    <Root disableEndMargin={disableEndMargin} content={<PopoverContent>{tooltipTitle}</PopoverContent>}>
      <IconButton disabled={disabled} size="small" variant={iconButtonVariant} onClick={onClick}>
        {icon}
      </IconButton>
    </Root>
  );
};

export default ActionButton;
